import {Broadcast} from 'broadcasts'
import {SERVICE_REFRESH_TOKEN_TIMEOUT} from 'consts'
import {v4 as uuid} from 'uuid'

interface BroadcastRefreshTokenMessage {
  is_active: boolean
}

interface RefreshActivity {
  /** If active, refresh_id is not null */
  refresh_id: string | null
  retryQueue: Function[]
}

export const channelRefreshToken = new Broadcast<BroadcastRefreshTokenMessage>(
  'refresh-token',
)

export const refreshActivity: RefreshActivity = {
  refresh_id: null,
  retryQueue: [],
}

async function onRefreshChangeActivation(
  event: MessageEvent<BroadcastRefreshTokenMessage>,
) {
  const {is_active} = event.data
  const uniqueId = uuid()

  refreshActivity.refresh_id = uniqueId

  /**
   * When deactivated or timeout, retry all failed requests.
   * This is called in the broadcast listener because each tab needs to be informed to resend all queued requests.
   */
  const handleRetry = () => {
    refreshActivity.retryQueue.forEach((retry) => retry())
    refreshActivity.retryQueue = []
  }

  const handleDisableRefresh = () => {
    refreshActivity.refresh_id = null
    handleRetry()
  }

  /** If the caller tab is closed during the refresh, the refresh_id will remain the same, so disable the refresh activity. */
  const handleTimeout = () => {
    if (refreshActivity.refresh_id === uniqueId) {
      handleDisableRefresh()
    }
  }

  if (is_active) {
    setTimeout(handleTimeout, SERVICE_REFRESH_TOKEN_TIMEOUT)
  } else {
    handleDisableRefresh()
  }
}

channelRefreshToken.addEventListener('message', onRefreshChangeActivation)
